import { StorageManager } from 'src/app/common/storage-manager.class';
import { environment } from 'src/environments/environment';

export class TrazabilidadEnvironmentDefinition {
    public rol = StorageManager.getUser().rol;
    public appName = environment.appName;
    public serverUrl = environment.serverUrl;
    public hasClients = environment.features.hasClients;
    public clienteName = environment.features.clienteName;
    public userCanSeeClientes = environment.features.userCanSeeClientes
        ? true
        : this.rol === 'admin';
    public canAdd = environment.features.canAddTareas;
    public canDuplicate = environment.features.canDuplicateTareas;

    public fincaName = environment.features.fincaName;
    public sectorName = environment.features.sectorName;
    public parcelaName = environment.features.parcelaName;
}